import ModelProxy from "../model-proxy"

import {ITEM_TYPE_TIME_REPORT} from "../../gd/const/item"
import ModelEntity from "../model-entity"
import Task from "../task/task"
import DatetimeUtils from "../../gd/utils/datetime-utils"
import timeReport_autoCorrectDurationAndStartEnd from "./actions/auto-correct-duration-and-start-end"
import ApiTimeReport from "../../gd/api/time-reports/time-report"
import ErrorProto from "../../gd/validation/error"
import ErrorFieldRequired from "../../gd/validation/error-field-required"
import UserManager from "../../manager/user-manager/user-manager"
import Meeting from "../meeting/meeting"
import Project from "../project/project"
import {TimeReport_ActivityType} from "./@const"

// const debug = "TimeReport"
const debug = false

export default class TimeReport extends ModelEntity {

    public userId                   : ID
    public _reportedTimeMinutes     : number | null
    public estimatedTimeMinutes     : number          // is it GUESSTIMATE !!! yes - in backend wrong ield name

    public reportType               : any // ???
    public companyId                : ID

    public taskId                   : ID
    // public projectId?                  : ID
    public meetingId?               : ID

    public isBillable               : boolean

    private _date                   : MomentDate | null

    public taskMessageId            : ID
    public momentCreated            : Moment | null
    public isDeleted                : boolean
    public skipEstimating           : boolean

    public commentTxt               : string

    public message                  : string
    public messageRTF               : any

    public task                     : Task | any = null
    public meeting                  : Meeting | null = null

    public taskMessage              : any

    public _startMoment?            : Moment | null
    public _endMoment?              : Moment | null

    public isFakeGuesstimate?       : boolean           // used only in my time
    public isPlaceholder            : boolean = false
    public activityType?            : TimeReport_ActivityType   // set by MyTimeDaily during item collection init

    constructor(data: any, useProxy = true) {
        super(data['id'], ITEM_TYPE_TIME_REPORT);

        this.userId = data['userId']
        this.taskId = data['taskId']
        this.meetingId = data['meetingId']
        this._reportedTimeMinutes = data['reportedTimeMinutes'] || data['reportedTime'] || data['reportedMinutes'] // in portfolio we dont' have "minutes" // in reports its reportedMinutes

        this.reportType = data['reportType']
        this.companyId = data['companyId']


        // Seichas v DB it can be NONE -> so set to True here...
        // ya reshil taki sdelat' fixed value ... potom update na not null
        this.isBillable = _.get(data, 'isBillable', gd.modules.timeTracking.defaultIsBillable)
        if (!_.isBoolean(this.isBillable)) {
            this.isBillable = true
            //     this.isBillable = gd.modules.timeTracking.defaultIsBillable
        }

        // this.date                   = data['date'] ? DatetimeUtils.dateToMoment(data['date']) : null
        this._date = data['date'] ? momentDate(data['date']) as MomentDate : null
        this.estimatedTimeMinutes = data['estimatedTimeMinutes'] || data['estimatedMinutes']
        // this.taskId                 = data['taskId']
        this.taskMessageId = data['taskMessageId']
        this.momentCreated = data['momentCreated'] ? DatetimeUtils.datetimeToMoment(data['momentCreated']) : null
        this.isDeleted = data['isDeleted']
        this.skipEstimating = data['skipEstimating']

        // commentTxt is used in data response for time reports and My time reports
        this.message    = data['message'] || data.commentTxt
        this.messageRTF = data['messageRTF']

        this.task   = _.get(data, 'task', null)  // used in time report view

        // meeting reports carry the meeting instead of a task. daily/weekly send a compact
        // {id, name, projectId} - Meeting tolerates it; item view GET sends the full object
        const meetingData = _.get(data, 'meeting', null)
        if (meetingData) {
            this.meeting = meetingData instanceof Meeting ? meetingData : new Meeting(meetingData, false)
        }

        // this.taskMessage            = new TaskMessage(data.taskMessage)
        this.taskMessage = data['taskMessage']
        if (data.commentTxt && !this.taskMessage?.message) {
            this.taskMessage = {
                message     : data.commentTxt,
                messageRtf  : undefined,
            }
        }
        this.commentTxt             = _.get(data, 'commentTxt', this.taskMessage?.message)

        this.isFakeGuesstimate = _.get(data, 'isFakeGuesstimate', undefined)

        // a meeting guesstimate carries the real calendar slot of the meeting, unlike a task
        // guesstimate which is just a share of the remaining workday
        if (!this.isGuesstimate || this.meetingId) {
            this._startMoment = data['startMoment'] ? DatetimeUtils.datetimeToMoment(data['startMoment']) : undefined
            this._endMoment = data['endMoment'] ? DatetimeUtils.datetimeToMoment(data['endMoment']) : undefined
        }


        return useProxy ? new Proxy(this, ModelProxy) : this;
    }

    applyDelta(data:any) {
        let isChanged = false

        const isSameValue = (paramName:string, value:any) => {
            // @ts-ignore
            if (Moment.isMoment(this[paramName])) {
                // @ts-ignore
                return DatetimeUtils.isSame(this[paramName], DatetimeUtils.dateToMoment(value), 'day')
            } else {
                // @ts-ignore
                return _.isEqual(this[paramName], value)
            }
        }

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return;

            debug && console.log(debug, "applyDelta", "key=", key, "value=", value)

            const updateParamsNames = []
            switch (key) {
                case 'reportedTimeMinutes'  :
                case 'reportedTime'         :
                case 'reportedMinutes'      : updateParamsNames.push('reportedTimeMinutes'); break

                case 'estimatedTimeMinutes' :
                case 'estimatedMinutes'     : updateParamsNames.push('estimatedTimeMinutes'); break

                default                     : updateParamsNames.push(key)
            }

            debug && console.log(debug, "applyDelta updateParamsNames=", updateParamsNames)
            _.map(updateParamsNames, paramName=>{
                switch (paramName) {
                    case 'date'            :
                        if (!isSameValue(paramName, value)) {
                            this.date   = momentDate(value) as MomentDate
                            isChanged   = true
                        }
                        break

                    case 'startMoment'      :
                    case 'endMoment'        :
                        const moment = value ? DatetimeUtils.datetimeToMoment(value) : null
                        if (!isSameValue(paramName, moment)) {
                            this[paramName] = moment
                            isChanged       = true
                        }
                        break

                    case 'momentCreated'            :
                        if (!isSameValue(paramName, value)) {
                            this.momentCreated  = DatetimeUtils.datetimeToMoment(value)
                            isChanged = true
                        }
                        break

                    default                         :
                        debug && console.log(debug, "applyDelta paramName=", paramName, !isSameValue(paramName, value), _.get(this,paramName), value)

                        if (!isSameValue(paramName, value)) {
                            // @ts-ignore
                            this[paramName] = value;
                            isChanged = true
                        }
                }
            })
        })

        debug && console.log(debug, "applyDelta isChanged", isChanged, this)

        return isChanged
    }

    get canEdit() {
        if (gd.viewMode === 'shared-view') return false
        const isReportOwner = this.userId === gd.user.id

        // check manager access
        // to - do in future
        // read managers for user in session etc.
        const userManager = new UserManager()
        const managerIds = userManager.getManagerForUsersIds(gd.companyId)
        const isManagerForReportOwner = managerIds.includes(this.userId)

        const reportingLimit    = gd.ac.check.company.isManager() ? gd.company.settings.labs.timeReport.reportingLimitManager : gd.company.settings.labs.timeReport.reportingLimit
        const reportingDays     = gd.ac.check.company.isManager() ? gd.company.settings.labs.timeReport.reportingDaysManager : gd.company.settings.labs.timeReport.reportingDays

        const editMaxDate       = reportingLimit ? moment(this.momentCreated).add(reportingDays,'days') : undefined
        const isEditAllowedByLimit = !editMaxDate || editMaxDate.isSameOrAfter(moment(), 'day')

        debug && console.log(debug, "canEdit", isReportOwner, isManagerForReportOwner, isEditAllowedByLimit)

        return (isReportOwner || isManagerForReportOwner) && isEditAllowedByLimit
    }

    // is required for sorting
    get title(): string | undefined {
        if (!this.entity) {
            return undefined
        }

        if (this.entity.hasOwnProperty('title')) {
            return (this.entity as any).title
        } else if (this.entity.hasOwnProperty('name')) {
            return (this.entity as any).name
        }

        return undefined
    }

    save() {
        const params = {}

        // reportedTimeMinutes
        if (this.updatedFields.has('reportedTimeMinutes')) {
            gd.api.MyTime.updateTimeReport(this.id, this.reportedTimeMinutes!)
            this.updatedFields.delete('reportedTimeMinutes')
        }

        // // startMoment
        // if (this.updatedFields.has('startMoment')) {
        //     gd.api.MyTime.updateTimeReport(this.id, this.reportedTimeMinutes)
        //     this.updatedFields.delete('startMoment')
        // }

        // date
        if (this.updatedFields.has('date')) {
            gd.api.MyTime.updateTimeReportDate(this.id, this.date!)
            this.updatedFields.delete('date')
        }

        // messageRTF
        if (this.updatedFields.has('messageRTF')) {
            gd.api.MyTime.updateTimeReportMessage(this.id, this.message, this.messageRTF)
            this.updatedFields.delete('message')
            this.updatedFields.delete('messageRTF')
        }

        // this is for universal update
        this.updatedFields.forEach((fieldName) => {
            // @ts-ignore
            params[fieldName] = this[fieldName]
        })

        this.updatedFields.clear()

        console.log("Time report save", this.id, params)
        // if (params && _.size(params)>0) gd.api.Event.update(this.id, params)
    }


    async saveUniversal() {
        // this is for universal update

        debug && console.log(debug, "saveUniversal", [...this.updatedFields])
        const params = {}

        this.updatedFields.forEach((fieldName) => {
            switch (fieldName) {
                default                     :
                    // @ts-ignore
                    params[fieldName] = this[fieldName]
                    break
            }
        })

        this.updatedFields.clear()

        debug && console.log(debug, "saveUniversal", this.id, params)
        if (params && _.size(params)>0) {
            return await ApiTimeReport.update(this.id, params).promise()
        }

        return true
    }

    get date(): MomentDate | null {
        return this._date
    }

    set date(value: MomentDate | null) {
        this._date = value

        if (this._startMoment)  {
            this._startMoment   = value ? DatetimeUtils.setTime(value,this._startMoment) : null
            this.updatedFields.add('startMoment')
        }
        if (this._endMoment)    {
            this._endMoment     = value ? DatetimeUtils.setTime(value,this._endMoment) : null
            this.updatedFields.add('endMoment')
        }
    }

    get reportedTimeMinutes() {
        return this._reportedTimeMinutes
    }

    set reportedTimeMinutes(value: number | null) {
        this._reportedTimeMinutes = value
        timeReport_autoCorrectDurationAndStartEnd(this, 'reportedTimeMinutes')
    }

    // Alias so the item-model aggregator (fieldId: 'reportedTime') picks this up when summing children
    get reportedTime() {
        return this._reportedTimeMinutes
    }

    set reportedTime(value: number | null) {
        this._reportedTimeMinutes = value
        timeReport_autoCorrectDurationAndStartEnd(this, 'reportedTimeMinutes')
    }

    get startMoment (): Moment | undefined | null {
        return this._startMoment
    }

    set startMoment(moment:Moment|null|undefined) {
        if (!moment) {
            this._startMoment = null
        } else {
            this._startMoment = moment
        }
        timeReport_autoCorrectDurationAndStartEnd(this, 'startMoment')
    }

    get endMoment (): Moment| undefined | null {
        return this._endMoment
    }

    set endMoment(moment: Moment | null | undefined ) {
        this._endMoment  = moment
        timeReport_autoCorrectDurationAndStartEnd(this, 'endMoment')
    }

    get reportedTimeHours() {
        if (!this._reportedTimeMinutes) return 0
        return this._reportedTimeMinutes / 60
    }

    get costInternal() {
        if (!this.reportedTimeMinutes) return 0

        if (!gd._hourlyCost) {
            // console.error("#tr-14847233 not initialized ")
            return 0
        }

        return gd._hourlyCost.calculateLaborCost(this)
    }

    get costExternal() {
        if (!this.reportedTimeMinutes) return 0

        if (!gd._hourlyCost) {
            // console.error("#tr-94847233 not initialized ")
            return 0
        }

        // return gd.utils.roundToDecimals(gd._hourlyCost.calculateServiceCost(this))
        return gd._hourlyCost.calculateServiceCost(this)
    }

    get reportedByUsersIds(): ID[] {
        return [this.userId]
    }

    get isMeetingReport(): boolean {
        return !!this.meetingId
    }

    // the work item the report is linked to - derived, so linking task / meeting later can never leave it stale
    get entity(): Task | Project | Meeting | undefined {
        return this.task || this.meeting || undefined
    }

    get projectId(): ID | null {
        if (this.task) return this.task.projectId
        if (this.meeting) return this.meeting.projectId ?? null
        return null
    }

    get projectPath(): ID | null {
        return this.projectId
    }

    get isGuesstimate() {
        return !this.reportedTimeMinutes && (this.estimatedTimeMinutes || this.skipEstimating)
    }

    validate():ErrorProto[] | null  {

        const errors : any[] = []

        // a report is linked to exactly one entity - task or meeting
        if (!this.taskId && !this.meetingId) errors.push(new ErrorFieldRequired(gd.fields.timeReport.taskId))
        if (!this.date) errors.push(new ErrorFieldRequired(gd.fields.timeReport.date))
        if (!this.userId) errors.push(new ErrorFieldRequired(gd.fields.timeReport.userId))
        if (!this.reportedTimeMinutes) errors.push(new ErrorFieldRequired(gd.fields.timeReport.reportedTime))

        // if (this.isText) {
        //     if (!this.contentTXT) errors.push(new ErrorFieldRequired(gd.fields.emailTemplate.contentTXT))
        // }
        //
        // if (this.isHtml) {
        //     if (!this.contentTXT) errors.push(new ErrorFieldRequired(gd.fields.emailTemplate.contentHTML))
        // }

        if (_.isEmpty(errors)) return null
        else return errors
    }

    clone():TimeReport {
        return new TimeReport(this.toJSON())
    }

    // used in task reply - when we attach timeReport to new message
    toPayload() {
        return {
            reportedTimeMinutes : this.reportedTimeMinutes,
            date                : this.date,
            startMoment         : this.startMoment || null,    // need null because undfined does not create a key in object !!!
            endMoment           : this.endMoment || null,      // need null because undfined does not create a key in object !!!
            isBillable          : this.isBillable
        }
    }

    toJSON(): JSONObject {
        return {
            id                      : this.id,
            userId                  : this.userId,

            isBillable              : this.isBillable,

            reportedTimeMinutes     : this.reportedTimeMinutes,
            estimatedTimeMinutes    : this.estimatedTimeMinutes,

            startMoment             : this.startMoment ? DatetimeUtils.momentToUTCISODatetime(this.startMoment) : undefined,
            endMoment               : this.endMoment ? DatetimeUtils.momentToUTCISODatetime(this.endMoment) : undefined,

            reportType              : this.reportType,
            companyId               : this.companyId,
            taskId                  : this.taskId,
            meetingId               : this.meetingId,

            date                    : DatetimeUtils.momentToDate(this.date),

            taskMessageId           : this.taskMessageId,
            momentCreated           : DatetimeUtils.momentToUTCISODatetime(this.momentCreated),
            isDeleted               : this.isDeleted,
            skipEstimating          : this.skipEstimating,

            commentTxt              : this.commentTxt,

            message                 : this.message,
            messageRTF              : this.messageRTF,

            task                    : this.task?.toJSON ?
                this.task?.toJSON(['timeReports']) // 'timeReports' are skipped to avoid infinite loop toJSON
                :
                this.task,

            meeting                 : this.meeting ? this.meeting.toJSON() : null,

            taskMessage             : this.taskMessage
        }
    }
}



